import React, { useEffect, useState } from 'react'
import {
  Form,
  Input,
  DatePicker,
  Select,
  Button,
  Row,
  Col,
  Space,
  message,
  Divider,
  Radio,
  Upload,
  Table,
  Checkbox,
  Modal,
  Spin,
  Card,
} from 'antd'
import {
  PlusOutlined,
  DeleteOutlined,
  UploadOutlined,
  EditOutlined,
  CheckOutlined,
  EyeOutlined,
  CheckSquareOutlined,
  BorderOutlined,
} from '@ant-design/icons'
import dayjs from 'dayjs'
import './StudentAdmissionForm.css'
import AdminHeader from '../CommonComponents/AdminHeader'
import AdminFooter from '../CommonComponents/AdminFooter'
import {
  CreateStudentAdmission,
  DeleteStudentAdmission,
  getActSection,
  GetAllFormStatusOfStudent,
  getCast,
  getCastById,
  getReligion,
  GetStudentAdmission,
  getSubCastById,
  IMG_URL,
  UpdateStudentAdmission,
} from '../APIComponents/AdminApi'
import { toast } from 'react-toastify'
import axiosInstance from '../../Utils/axiosInstance'
import axios from 'axios'

const { Option } = Select

const StudentAdmissionForm = () => {
  //===============================================
  const loginType = sessionStorage.getItem('loginType') // 'ADMIN' or 'USER'
  const menuData = JSON.parse(sessionStorage.getItem('menus')) || []

  const getPagePermission = () => {
    if (loginType === 'ADMIN') {
      return {
        is_new: 1,
        is_edit: 1,
        is_view: 1,
        is_delete: 1,
      }
    }

    for (const menu of menuData) {
      const page = menu.pages?.find((p) => p.page_name === 'Admission Form')
      if (page) return page
    }

    return {
      is_new: 0,
      is_edit: 0,
      is_view: 0,
      is_delete: 0,
    }
  }

  const pagePermission = getPagePermission()
  const showActionColumn =
    loginType === 'ADMIN' ||
    pagePermission.is_edit == 1 ||
    pagePermission.is_view == 1 ||
    pagePermission.is_delete == 1
  //============================================

  const [form] = Form.useForm()
  const [data, setData] = useState([])
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteId, setDeleteId] = useState(null)
  const [showForm, setShowForm] = useState(false)
  const [member, setMember] = useState({
    name: '',
    relation: '',
    age: '',
    gender: '',
    occupation: '',
    contact: '',
  })
  const [loading, setLoading] = useState(false)
  const [familyList, setFamilyList] = useState([])
  const [editIndex, setEditIndex] = useState(null)
  const [sameAddress, setSameAddress] = useState(false)
  const [photo, setPhoto] = useState(null)
  const [editId, setEditId] = useState(null)

  const [religions, setReligions] = useState([])
  const [casts, setCasts] = useState([])
  const [subCasts, setSubCasts] = useState([])
  const [selectedReligion, setSelectedReligion] = useState(null)
  const [selectedCast, setSelectedCast] = useState(null)
  const [actSections, setActSections] = useState([])

  const [searchText, setSearchText] = useState('')
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [editLoading, setEditLoading] = useState(false)
  const [editData, setEditData] = useState(null)

  const [viewModalVisible, setViewModalVisible] = useState(false)
  const [viewData, setViewData] = useState(null)
  const [photoPreview, setPhotoPreview] = useState(null)

  const [statusData, setStatusData] = useState({})

  const formatName = (key) => {
    return key
      .replace(/Form\d+_/g, '')
      .replace(/([A-Z])/g, ' $1')
      .trim()
  }

  const handleViewStudent = (record) => {
    setViewData(record)
    setViewModalVisible(true)

    axios.get(`${GetAllFormStatusOfStudent}/${record.id}`).then((res) => {
      setStatusData(res.data)
    })
  }

  //  Fetch all religions
  useEffect(() => {
    axiosInstance
      .get(getReligion) // 🔹 your religion API
      .then((res) => {
        setReligions(res.data)
      })
      .catch(() => toast.error('Failed to load religions'))
  }, [])

  //  Fetch all casts
  const fetchCastsByReligion = async (religionId) => {
    try {
      const res = await axiosInstance.get(`${getCastById}/${religionId}`)

      if (Array.isArray(res.data)) {
        setCasts(res.data)
      } else if (res.data.data && Array.isArray(res.data.data)) {
        setCasts(res.data.data)
      } else {
        setCasts([])
      }
    } catch (err) {
      toast.error('Failed to load casts')
      setCasts([])
    }
  }

  //  Fetch SubCast by Cast
  const fetchSubCastByCast = async (castId) => {
    try {
      const res = await axiosInstance.get(`${getSubCastById}/${castId}`)
      setSubCasts(res.data || [])
    } catch {
      setSubCasts([])
    }
  }

  //  Fetch all Act & Section
  useEffect(() => {
    setLoading(true)
    axiosInstance
      .get(getActSection) //  your GET API endpoint
      .then((res) => {
        setActSections(res.data) // ensure API returns an array of {id, name}
      })
      .catch(() => {
        toast.error('Failed to load Act and Section list')
      })
      .finally(() => setLoading(false))
  }, [getActSection])

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked
    setSameAddress(checked)

    if (checked) {
      // Copy current address to permanent address
      const currentAddress = form.getFieldValue('currentAddress')
      form.setFieldsValue({ permanentAddress: currentAddress })
    } else {
      // Clear permanent address when unchecked
      form.setFieldsValue({ permanentAddress: '' })
    }
  }

  //  Add or Update Member
  const handleAddOrUpdate = () => {
    if (
      !member.name ||
      !member.relation ||
      !member.age ||
      !member.gender ||
      !member.occupation ||
      !member.contact
    ) {
      return toast.warning('Please fill all fields before adding or updating!')
    }

    if (editIndex !== null) {
      //  Update existing member
      const updatedList = [...familyList]
      updatedList[editIndex] = member
      setFamilyList(updatedList)
      setEditIndex(null)
      toast.success('Member updated successfully!')
    } else {
      //  Add new member
      setFamilyList([...familyList, member])
      toast.success('Member added successfully!')
    }

    // Reset form after add/update
    setMember({
      name: '',
      relation: '',
      age: '',
      gender: '',
      occupation: '',
      contact: '',
    })
  }

  //  Delete Member
  const handleDelete = (index) => {
    const updated = [...familyList]
    updated.splice(index, 1)
    setFamilyList(updated)
    toast.success('Member deleted!')
  }

  //  Edit Member
  const handleEdit = (index) => {
    setMember(familyList[index]) // Load the selected member into input fields
    setEditIndex(index) // Mark which member is being edited
  }

  //  Table Columns on form page
  const columns = [
    {
      title: 'Sr No',
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    { title: 'Name', dataIndex: 'name' },
    { title: 'Relation', dataIndex: 'relation' },
    { title: 'Age', dataIndex: 'age' },
    { title: 'Gender', dataIndex: 'gender' },
    { title: 'Occupation', dataIndex: 'occupation' },
    { title: 'Contact', dataIndex: 'contact' },
    {
      title: 'Action',
      render: (_, record, index) => (
        <>
          <Button
            type="text"
            icon={<EditOutlined />}
            onClick={() => handleEdit(index)}
          />
          <Button
            type="text"
            danger
            icon={<DeleteOutlined />}
            onClick={() => handleDelete(index)}
          />
        </>
      ),
    },
  ]

  // ==============================================================================

  // ================= GET LIST =================
  const fetchAdmissions = async () => {
    try {
      setLoading(true)
      const res = await axiosInstance.get(GetStudentAdmission)
      setData(res.data)
    } catch (err) {
      message.error('Failed to fetch data')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchAdmissions()
  }, [])

  // ================= DELETE =================
  const handleDeleteStudent = async () => {
    try {
      const res = await axiosInstance.delete(
        `${DeleteStudentAdmission}/${deleteId}`,
      )
      if (res.data === 'DELETED_SUCCESSFULLY') {
        toast.success('Deleted successfully')
        setDeleteModal(false)
        fetchAdmissions()
      } else if (res.data === 'NOTFOUND') {
        toast.warn('Data not found!')
      }
    } catch (err) {
      toast.error('Delete failed')
    }
  }

  // ================= EDIT =================
  const handleEditStudent = async (record) => {
    try {
      setEditData(record)
      setEditLoading(true)
      setShowForm(true)
      setEditId(record.id)

      // Small delay to allow form render (optional but recommended)
      await new Promise((resolve) => setTimeout(resolve, 200))

      // Reset previous edit states
      setEditIndex(null)
      setMember({
        name: '',
        relation: '',
        age: '',
        gender: '',
        occupation: '',
        contact: '',
      })

      // ===========================
      // Student Photo
      // ===========================
      // const studentPhotoFileList = record.pic
      //   ? [
      //       {
      //         uid: '-1',
      //         name: record.pic,
      //         status: 'done',
      //         url: IMG_URL + record.pic,
      //       },
      //     ]
      //   : []

      if (record.pic) {
        setPhotoPreview(IMG_URL + record.pic)
      }

      const studentPhotoFileList = record.pic
        ? [
            {
              uid: '-1',
              name: record.pic,
              status: 'done',
              url: IMG_URL + record.pic,
              thumbUrl: IMG_URL + record.pic,
            },
          ]
        : []

      // ===========================
      // School LC
      // ===========================
      // const schoolLCFileList = record.educationinfo?.school_leaving_certificate
      //   ? [
      //       {
      //         uid: '-2',
      //         name: record.educationinfo.school_leaving_certificate,
      //         status: 'done',
      //         url: IMG_URL + record.educationinfo.school_leaving_certificate,
      //       },
      //     ]
      //   : []

      const schoolLCFileList = record.educationinfo?.school_leaving_certificate
        ? [
            {
              uid: '-2',
              name: record.educationinfo.school_leaving_certificate,
              status: 'done',
              url: IMG_URL + record.educationinfo.school_leaving_certificate,
              thumbUrl:
                IMG_URL + record.educationinfo.school_leaving_certificate,
            },
          ]
        : []

      // ===========================
      // Family Members Format
      // ===========================
      const formattedFamily =
        record.familyMembers?.map((member) => ({
          id: member.id,
          name: member.name,
          relation: member.relation,
          age: member.age?.toString(),
          gender:
            member.gender === 1
              ? 'female'
              : member.gender === 2
              ? 'male'
              : member.gender,
          occupation: member.occupation,
          contact: member.contact?.toString(),
        })) || []

      setFamilyList(formattedFamily)

      // ===========================
      // Extract Nested Data
      // ===========================
      const medical = record.medicalinfo || {}
      const education = record.educationinfo || {}
      const welfare = record.child_welfare_committee_details?.[0] || {}
      const background = record.family_background?.[0] || {}

      // ===========================
      //  DEPENDENT DROPDOWN FIX
      // ===========================

      setSelectedReligion(record.religion_id)
      setSelectedCast(null)
      setCasts([])
      setSubCasts([])

      if (record.religion_id) {
        await fetchCastsByReligion(record.religion_id)
      }

      if (record.caste_id) {
        setSelectedCast(record.caste_id)
        await fetchSubCastByCast(record.caste_id)
      }

      // ===========================
      //  Set Form Values
      // ===========================
      form.setFieldsValue({
        // ===== Personal Info =====
        admissionType: record.admission_type?.toString(),
        regNo: record.reg_no?.toString(),
        firstName: record.fname,
        middleName: record.mname,
        lastName: record.lname,
        studentPhoto: studentPhotoFileList,
        gender: record.gender === 1 ? 'female' : 'male',
        admissionDate: record.admission_date
          ? dayjs(record.admission_date)
          : null,
        birthDate: record.birth_date ? dayjs(record.birth_date) : null,
        birthPlace: record.birth_place,
        religion: record.religion_id,
        cast: record.caste_id,
        subCast: record.sub_caste_id,
        trackChildNo: record.child_no?.toString(),
        aadhar: record.aadhar_no?.toString(),
        parentMobile: record.parent_mobile?.toString(),
        currentAddress: record.current_address,
        permanentAddress: record.permanent_address,
        policeStation: record.police_station_name,
        policeContact: record.police_contact?.toString(),

        // ===== Medical =====
        height: medical.height,
        weight: medical.weight,
        bloodGroup: medical.blood_group,
        periodDate: medical.menstrual_cycle_date
          ? dayjs(medical.menstrual_cycle_date)
          : null,
        healthHistory: medical.health_history,
        birthMark: medical.birth_mark_on_body,

        // ===== Education =====
        standard: education.standard || null,
        schoolName: education.school_name || null,
        medium: education.medium || null,
        schoolLeavingCertificate: schoolLCFileList,

        // ===== Welfare =====
        firstFiledOrderDate: welfare.first_filed_order_date
          ? dayjs(welfare.first_filed_order_date)
          : null,
        formOfOrder: welfare.form_of_order?.toString(),
        actAndSection: welfare.act_and_section_id
          ? welfare.act_and_section_id.split(',').map((id) => Number(id.trim()))
          : [],
        childDetails: welfare.child_details,

        // ===== Family Background =====
        visitorName: background.visitor_name,
        visitorRelation: background.visitor_relation,
        personName: background.person_name,
        personRelation: background.person_relation,
        childrenCaseHistory: background.children_case_history,
      })
    } catch (error) {
      console.error(error)
    } finally {
      setEditLoading(false) //  Stop Loader
    }
  }

  // ================ SAVE DATA ==============================================================
  const onFinish = async (values) => {
    setLoading(true)
    try {
      const formData = new FormData()

      // ========================
      //  BASIC DETAILS
      // ========================
      formData.append('status', 1) //Discharge Status (1=> Current, 2=> Discharge)
      formData.append('admission_type', values.admissionType)
      formData.append('reg_no', values.regNo)
      formData.append('fname', values.firstName)
      formData.append('mname', values.middleName)
      formData.append('lname', values.lastName)

      // Convert gender (female=1, male=2 OR change as per backend)
      formData.append('gender', values.gender === 'female' ? 1 : 2)

      formData.append(
        'admission_date',
        values.admissionDate?.format('YYYY-MM-DD'),
      )

      // formData.append('birth_date', values.birthDate?.format('YYYY-MM-DD'))
      formData.append('birth_date', values.birthDate?.format('YYYY-MM-DD') || '')

      formData.append('birth_place', values.birthPlace)
      formData.append('religion_id', values.religion)
      formData.append('caste_id', values.cast)
      formData.append('sub_caste_id', values.subCast)
      formData.append('child_no', values.trackChildNo || null)
      formData.append('aadhar_no', values.aadhar || null)
      formData.append('parent_mobile', values.parentMobile || null)

      formData.append('current_address', values.currentAddress || null)
      formData.append('permanent_address', values.permanentAddress || null)
      formData.append('police_station_name', values.policeStation || null)
      formData.append('police_contact', values.policeContact || null)

      // ========================
      //  FAMILY MEMBERS
      // ========================
      const formattedFamily = familyList.map((item) => ({
        name: item.name,
        relation: item.relation,
        age: Number(item.age),
        gender: item.gender === 'female' ? 1 : 2,
        occupation: item.occupation,
        contact: item.contact,
      }))

      formData.append('familyMembers', JSON.stringify(formattedFamily || null))

      // ========================
      //  CWC DETAILS
      // ========================
      formData.append(
        'first_filed_order_date',
        values.firstFiledOrderDate?.format('YYYY-MM-DD'),
      )

      formData.append('form_of_order', values.formOfOrder)

      if (values.actAndSection && values.actAndSection.length > 0) {
        const actIds = values.actAndSection.join(',')
        formData.append('act_and_section_id', actIds)
      }

      formData.append('child_details', values.childDetails)

      // ========================
      //  MEDICAL
      // ========================
      formData.append('height', values.height)
      formData.append('weight', values.weight)
      formData.append('blood_group', values.bloodGroup)
      formData.append(
        'menstrual_cycle_date',
        values.periodDate?.format('YYYY-MM-DD') || null,
      )
      formData.append('health_history', values.healthHistory || null)
      formData.append('birth_mark_on_body', values.birthMark || null)

      // ========================
      //  EDUCATION
      // ========================
      formData.append('standard', values.standard || null)
      formData.append('school_name', values.schoolName || null)
      formData.append('medium', values.medium || null)

      // ========================
      //  FAMILY BACKGROUND
      // ========================
      formData.append('visitor_name', values.visitorName || null)
      formData.append('visitor_relation', values.visitorRelation || null)
      formData.append('person_name', values.personName || null)
      formData.append('person_relation', values.personRelation || null)
      formData.append(
        'children_case_history',
        values.childrenCaseHistory || null,
      )

      // ==========================
      // STUDENT PHOTO
      // ==========================
      if (values.studentPhoto?.[0]) {
        const photoFile = values.studentPhoto[0]

        if (photoFile.originFileObj) {
          //  New uploaded file
          formData.append('pic', photoFile.originFileObj)
        } else {
          //  Old existing file
          formData.append('pic', photoFile.name)
        }
      }

      // ==========================
      // SCHOOL LEAVING CERTIFICATE
      // ==========================
      if (values.schoolLeavingCertificate?.[0]) {
        const certFile = values.schoolLeavingCertificate[0]

        if (certFile.originFileObj) {
          //  New uploaded file
          formData.append('school_leaving_certificate', certFile.originFileObj)
        } else {
          //  Old existing file
          formData.append('school_leaving_certificate', certFile.name)
        }
      }

      let response
      if (editId) {
        // UPDATE API
        // formData.append('id', editId)

        response = await axiosInstance.put(
          `${UpdateStudentAdmission}/${editId}`,
          formData,
          {
            headers: { 'Content-Type': 'multipart/form-data' },
          },
        )
      } else {
        // CREATE API
        response = await axiosInstance.post(CreateStudentAdmission, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })
      }

      if (response.data === 'SAVED' || response.data === 'UPDATED') {
        toast.success(editId ? 'Updated Successfully!' : 'Saved Successfully!')

        form.resetFields()
        setShowForm(false)
        setEditId(null)
        fetchAdmissions()
        setFamilyList([])
        setPhotoPreview(null)
        form.setFieldsValue({
          gender: 'female',
          admissionDate: dayjs(),
        })

        //  Clear member input state
        setMember({
          name: '',
          relation: '',
          age: '',
          gender: '',
          occupation: '',
          contact: '',
        })

        setPhoto(null)
        setEditIndex(null)
        setSameAddress(false)
        setSelectedCast(null)
      }

      if (response.data == 'ERROR') {
        toast.error('Error occurred! Try Again')
      }
    } catch (error) {
      toast.error('Submission failed')
    } finally {
      setLoading(false)
    }
  }
  // ==================================================

  // ================= TABLE COLUMNS =================
  const tableColumns = [
    {
      title: 'Sr No',
      render: (_, __, index) => (currentPage - 1) * pageSize + index + 1,
    },
    {
      title: 'Reg. No.',
      dataIndex: 'reg_no',
    },
    {
      title: 'Name',
      render: (_, record) =>
        `${record.fname || ''} ${record.mname || ''} ${record.lname || ''}`,
    },

    {
      title: 'Add Type',
      dataIndex: 'admission_type',
      render: (type) => {
        const typeMap = {
          1: 'Orphan',
          2: 'Semi',
          3: 'Pocso',
          4: 'Unfit Guardian',
          5: 'Child Line',
          6: 'Railway Child Line',
          7: 'Child Help Line',
          8: 'Missing',
          9: 'Child Trafficking',
        }

        return typeMap[type] || '—'
      },
    },
    {
      title: 'Admission Date',
      dataIndex: 'admission_date',
      render: (date) => (date ? dayjs(date).format('DD-MM-YYYY') : ''),
    },
    {
      title: 'Extension Date',
      render: (_, record) => {
        const date = record.extensions?.[0]?.max_date
        return date ? dayjs(date).format('DD-MM-YYYY') : '-'
      },
    },
    ...(showActionColumn
      ? [
          {
            title: 'Action',
            render: (_, record) => (
              <Space>
                {pagePermission.is_view == 1 && (
                  <Button
                    title="View"
                    icon={<EyeOutlined />}
                    onClick={() => handleViewStudent(record)}
                  />
                )}
                {pagePermission.is_edit == 1 && (
                  <Button
                    title="Edit"
                    icon={<EditOutlined />}
                    onClick={() => handleEditStudent(record)}
                  />
                )}
                {pagePermission.is_delete == 1 && (
                  <Button
                    title="Delete"
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => {
                      setDeleteId(record.id)
                      setDeleteModal(true)
                    }}
                  ></Button>
                )}
              </Space>
            ),
          },
        ]
      : []),
  ]

  const typeMap = {
    1: 'Orphan',
    2: 'Semi',
    3: 'Pocso',
    4: 'Unfit Guardian',
    5: 'Child Line',
    6: 'Railway Child Line',
    7: 'Child Help Line',
    8: 'Missing',
    9: 'Child Trafficking',
  }

  const filteredData = data.filter((item) => {
    const search = searchText.toLowerCase()

    const nameMatch =
      item.fname?.toLowerCase().includes(search) ||
      item.lname?.toLowerCase().includes(search)

    const typeText = typeMap[item.admission_type]?.toLowerCase() || ''
    const typeMatch = typeText.includes(search)

    return nameMatch || typeMatch
  })

  const genderMap = {
    1: 'Female',
    2: 'Male',
  }

  const admissionTypeMap = {
    1: 'Orphan',
    2: 'Semi',
    3: 'Pocso',
    4: 'Unfit Guardian',
    5: 'Child Line',
    6: 'Railway Child Line',
    7: 'Child Help Line',
    8: 'Missing',
    9: 'Child Trafficking',
  }

  const formOfOrderMap = {
    1: 'In Writing',
    2: 'WhatsApp',
  }

  // ======================================

  return (
    <>
      <AdminHeader />
      <div className="student-form-section container-fluid">
        <div className="student-form-wrapper pb-5">
          <div className="row student-form-title">
            <h3 className="section-title1 text-start mb-2">Admission Form</h3>
          </div>

          {!showForm && (
            <>
              <Row justify="space-between" className="mb-3">
                <Col xs={24} md={10} lg={14}></Col>
                <Col
                  xs={24}
                  md={6}
                  lg={4}
                  className="text-end px-md-2 pb-2 pb-md-0"
                >
                  {pagePermission.is_new == 1 && (
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setEditId(null)
                        form.resetFields()
                        setFamilyList([])
                        setMember({
                          name: '',
                          relation: '',
                          age: '',
                          gender: '',
                          occupation: '',
                          contact: '',
                        })
                        setEditIndex(null)
                        setShowForm(true)
                      }}
                    >
                      Add
                    </Button>
                  )}
                </Col>
                <Col xs={24} md={6} lg={6}>
                  <Input
                    placeholder="Search by name"
                    value={searchText}
                    onChange={(e) => setSearchText(e.target.value)}
                  />
                </Col>
              </Row>

              <Table
                columns={tableColumns}
                dataSource={filteredData}
                rowKey="id"
                bordered
                loading={loading}
                pagination={{
                  current: currentPage,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setCurrentPage(page)
                    setPageSize(size)
                  },
                }}
                className="custom-table shadow rounded border"
                style={{
                  overflowX: 'auto',
                  border: '1px solid #dfdfdf',
                  backgroundColor: 'white',
                }}
              />
            </>
          )}

          {showForm && (
            <Spin spinning={editLoading}>
              <div className="row student-form-container rounded shadow py-2">
                <Form
                  className="formDesign"
                  form={form}
                  layout="vertical"
                  onFinish={onFinish}
                  autoComplete="off"
                  initialValues={{
                    gender: 'female', //  Default gender value
                    admissionDate: dayjs(), //  Default admission date
                  }}
                >
                  {/* Student Info */}
                  <h5 className="mt-3">Personal Information - </h5>

                  <Row gutter={16} className="p-2 border rounded">
                    <Col xs={24} md={6} lg={6}>
                      <Form.Item
                        label="Admission Type"
                        name="admissionType"
                        rules={[
                          { required: true, message: 'Please select type' },
                        ]}
                      >
                        <Select placeholder="Select type">
                          <Option value="1">Orphan</Option>
                          <Option value="2">Semi</Option>
                          <Option value="3">Pocso</Option>
                          <Option value="4">Unfit Guardian</Option>
                          <Option value="5">Child Line</Option>
                          <Option value="6">Railway Child line</Option>
                          <Option value="7">Child Help Line</Option>
                          <Option value="8">Missing</Option>
                          <Option value="8">Child Trafficking</Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={5} lg={4}>
                      <Form.Item
                        label="Reg. No"
                        name="regNo"
                        rules={[
                          { required: true, message: 'Please enter reg no' },
                        ]}
                      >
                        <Input placeholder="Reg. No" />
                      </Form.Item>
                    </Col>

                    {/* === PHOTO UPLOAD SECTION === */}
                    <Col xs={24} md={8} lg={6} style={{ textAlign: 'center' }}>
                      <Form.Item
                        label="Student Photo"
                        name="studentPhoto"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => {
                          if (Array.isArray(e)) {
                            return e
                          }
                          return e?.fileList || []
                        }}
                      >
                        <Upload
                          accept=".jpg,.jpeg,.png"
                          beforeUpload={(file) => {
                            const isLt3M = file.size / 1024 / 1024 < 3

                            if (!isLt3M) {
                              toast.warn('File must be smaller than 3MB!')
                              return Upload.LIST_IGNORE
                            }

                            const reader = new FileReader()
                            reader.readAsDataURL(file)
                            reader.onload = () => {
                              setPhotoPreview(reader.result)
                            }

                            return false
                          }}
                          onChange={({ fileList }) => {
                            form.setFieldsValue({ studentPhoto: fileList })
                          }}
                          onRemove={() => {
                            setPhotoPreview(null)
                            form.setFieldsValue({ studentPhoto: [] })
                          }}
                          maxCount={1}
                          showUploadList={false}
                          style={{ width: '100%' }}
                        >
                          <Button
                            icon={<UploadOutlined />}
                            style={{ width: '100%' }}
                          >
                            Click to Upload (Max 3MB)
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={5} lg={4}>
                      {photoPreview && (
                        <div
                          style={{
                            marginTop: 10,
                            textAlign: 'center',
                            width: '100%',
                          }}
                        >
                          <img
                            src={photoPreview}
                            alt="Student"
                            style={{
                              width: '100%', // make image fill column width
                              height: 'auto', // keep aspect ratio
                              objectFit: 'contain',
                              borderRadius: 8,
                              border: '1px solid #ddd',
                            }}
                          />
                          <p className="text-black">Uploaded Image</p>
                        </div>
                      )}
                    </Col>

                    <Col xs={24} lg={4}></Col>

                    {/* === END PHOTO UPLOAD SECTION === */}

                    <Col xs={24} md={18} lg={15}>
                      <Form.Item
                        label="Name"
                        required
                        style={{ marginBottom: 0 }} // Removes extra bottom spacing
                      >
                        <Row gutter={8}>
                          <Col xs={24} md={8} className="py-1 py-lg-0">
                            <Form.Item
                              name="firstName"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter first name',
                                },
                              ]}
                            >
                              <Input placeholder="First Name" />
                            </Form.Item>
                          </Col>

                          <Col xs={24} md={8} className="py-1 py-lg-0">
                            <Form.Item
                              name="middleName"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter middle name',
                                },
                              ]}
                            >
                              <Input placeholder="Middle Name" />
                            </Form.Item>
                          </Col>

                          <Col xs={24} md={8} className="py-1 py-lg-0">
                            <Form.Item
                              name="lastName"
                              rules={[
                                {
                                  required: true,
                                  message: 'Please enter last name',
                                },
                              ]}
                            >
                              <Input placeholder="Last Name" />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={6} lg={9}></Col>

                    <Col xs={24} md={4} lg={3}>
                      <Form.Item
                        label="Gender"
                        name="gender"
                        rules={[
                          { required: true, message: 'Please select gender' },
                        ]}
                      >
                        <Select placeholder="Select gender">
                          <Option value="female">Female</Option>
                          <Option value="male">Male</Option>
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={6} lg={4}>
                      <Form.Item
                        label="Admission Date"
                        name="admissionDate"
                        rules={[
                          {
                            required: true,
                            message: 'Please select admission date',
                          },
                        ]}
                      >
                        <DatePicker
                          style={{ width: '100%' }}
                          format="DD-MM-YYYY"
                          // disabledDate={(current) => current && current > dayjs()}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={6} lg={4}>
                      <Form.Item label="Birth Date" name="birthDate">
                        <DatePicker
                          style={{ width: '100%' }}
                          format="DD-MM-YYYY"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={8} lg={7}>
                      <Form.Item
                        label="Birth Place"
                        name="birthPlace"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter birth place',
                          },
                        ]}
                      >
                        <Input placeholder="Enter birth place" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={0} lg={6}></Col>

                    <Col xs={24} md={5} lg={5}>
                      <Form.Item
                        label="Religion"
                        name="religion"
                        rules={[
                          { required: true, message: 'Please select religion' },
                        ]}
                      >
                        <Select
                          placeholder="Select religion"
                          allowClear
                          onChange={async (value) => {
                            setSelectedReligion(value)

                            form.setFieldsValue({
                              cast: undefined,
                              subCast: undefined,
                            })

                            setSelectedCast(null)
                            setCasts([])
                            setSubCasts([])

                            if (value) {
                              await fetchCastsByReligion(value)
                            }
                          }}
                        >
                          {religions.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.religion_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={5} lg={5}>
                      <Form.Item
                        label="Cast"
                        name="cast"
                        rules={[
                          { required: true, message: 'Please select cast' },
                        ]}
                      >
                        <Select
                          placeholder="Select Cast"
                          allowClear
                          disabled={!selectedReligion}
                          onChange={async (value) => {
                            setSelectedCast(value)

                            form.setFieldsValue({
                              subCast: undefined,
                            })

                            setSubCasts([])

                            if (value) {
                              await fetchSubCastByCast(value)
                            }
                          }}
                        >
                          {casts.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.cast_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={5} lg={5}>
                      <Form.Item
                        label="Sub Cast"
                        name="subCast"
                        rules={[
                          { required: true, message: 'Please select sub cast' },
                        ]}
                      >
                        <Select
                          placeholder="Select sub cast"
                          allowClear
                          disabled={!selectedCast}
                        >
                          {subCasts.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.subcast_name}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={0} lg={9}></Col>

                    <Col xs={24} md={6} lg={5}>
                      <Form.Item
                        label="Track The Child No"
                        name="trackChildNo"
                        rules={[
                          {
                            pattern: /^[0-9]*$/,
                            message: 'Only numeric value allowed',
                          },
                        ]}
                      >
                        <Input
                          placeholder="Enter tracking number"
                          inputMode="numeric"
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault()
                            }
                          }}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '')
                            form.setFieldsValue({ trackChildNo: value })
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={6} lg={5}>
                      <Form.Item
                        label="Aadhaar Card No"
                        name="aadhar"
                        rules={[
                          { len: 12, message: 'Aadhaar must be 12 digits' },
                          {
                            pattern: /^[0-9]*$/,
                            message: 'Only numbers allowed',
                          },
                        ]}
                      >
                        <Input
                          maxLength={12}
                          placeholder="Enter 12-digit Aadhaar number"
                          inputMode="numeric"
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault()
                            }
                          }}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '')
                            form.setFieldsValue({ aadhar: value })
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={6} lg={5}>
                      <Form.Item
                        label="Parents Mobile No"
                        name="parentMobile"
                        rules={[
                          {
                            len: 10,
                            message: 'Mobile number must be 10 digits',
                          },
                        ]}
                      >
                        <Input
                          maxLength={10}
                          placeholder="Enter 10-digit mobile number"
                          inputMode="numeric"
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault()
                            }
                          }}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '')
                            form.setFieldsValue({ parentMobile: value })
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={6} lg={9}></Col>

                    <Col xs={24} md={16} lg={16}>
                      <Form.Item
                        label="Current Address"
                        name="currentAddress"
                        // rules={[{ required: true, message: "Please enter current address" }]}
                      >
                        <Input.TextArea
                          rows={3}
                          placeholder="Enter current address"
                        />
                      </Form.Item>
                    </Col>

                    <Col
                      xs={24}
                      md={16}
                      lg={16}
                      className="flex items-center mb-3"
                    >
                      <Checkbox
                        checked={sameAddress}
                        onChange={handleCheckboxChange}
                      >
                        Permanent Address Same As Current Address
                      </Checkbox>
                    </Col>

                    <Col xs={24} md={8} lg={8}></Col>

                    <Col xs={24} md={16} lg={16}>
                      <Form.Item
                        label="Permanent Address"
                        name="permanentAddress"
                        // rules={[{ required: true, message: "Please enter permanent address" }]}
                      >
                        <Input.TextArea
                          rows={3}
                          placeholder="Enter permanent address"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={8} lg={8}></Col>

                    <Col xs={24} md={10} lg={8}>
                      <Form.Item label="Police Station" name="policeStation">
                        <Input placeholder="Enter police station name" />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={6} lg={4}>
                      <Form.Item
                        label="Police Contact No"
                        name="policeContact"
                        rules={[
                          {
                            len: 10,
                            message: 'Contact number must be 10 digits',
                          },
                        ]}
                      >
                        <Input
                          maxLength={10}
                          placeholder="Enter contact number"
                          inputMode="numeric"
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault()
                            }
                          }}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '')
                            form.setFieldsValue({ policeContact: value })
                          }}
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12} lg={12}></Col>
                  </Row>

                  <Divider />

                  {/* Family Information */}
                  <h5 className="mt-3">Family Information -</h5>

                  <Row
                    gutter={16}
                    className="p-2 border rounded"
                    style={{ background: '#fafafa' }}
                  >
                    <Col
                      xs={24}
                      sm={12}
                      md={18}
                      lg={7}
                      className="pb-2 pb-lg-0"
                    >
                      <Input
                        placeholder="Name"
                        value={member.name}
                        onChange={(e) =>
                          setMember({ ...member, name: e.target.value })
                        }
                      />
                    </Col>

                    <Col xs={24} sm={12} md={6} lg={3} className="pb-2 pb-lg-0">
                      <Input
                        placeholder="Relation"
                        value={member.relation}
                        onChange={(e) =>
                          setMember({ ...member, relation: e.target.value })
                        }
                      />
                    </Col>

                    <Col xs={12} sm={8} md={4} lg={2} className="pb-2 pb-lg-0">
                      <Input
                        placeholder="Age"
                        value={member.age}
                        maxLength={2}
                        onChange={(e) => {
                          if (/^\d*$/.test(e.target.value))
                            setMember({ ...member, age: e.target.value })
                        }}
                      />
                    </Col>

                    <Col xs={12} sm={8} md={6} lg={3} className="pb-2 pb-lg-0">
                      <Select
                        placeholder="Gender"
                        value={member.gender || undefined}
                        onChange={(val) =>
                          setMember({ ...member, gender: val })
                        }
                        style={{ width: '100%', height: '37px' }}
                      >
                        <Option value="male">Male</Option>
                        <Option value="female">Female</Option>
                      </Select>
                    </Col>

                    <Col xs={24} sm={12} md={8} lg={4} className="pb-2 pb-lg-0">
                      <Input
                        placeholder="Occupation"
                        value={member.occupation}
                        onChange={(e) =>
                          setMember({ ...member, occupation: e.target.value })
                        }
                      />
                    </Col>

                    <Col xs={24} sm={12} md={6} lg={3} className="pb-2 pb-lg-0">
                      <Input
                        placeholder="Contact No"
                        value={member.contact}
                        maxLength={10}
                        inputMode="numeric"
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault()
                          }
                        }}
                        onChange={(e) => {
                          const value = e.target.value.replace(/\D/g, '')
                          setMember({ ...member, contact: value })
                        }}
                      />
                    </Col>

                    <Col xs={24} lg={2} className="text-end">
                      <Button
                        icon={
                          editIndex !== null ? (
                            <CheckOutlined />
                          ) : (
                            <PlusOutlined />
                          )
                        }
                        onClick={handleAddOrUpdate}
                        style={{
                          backgroundColor:
                            editIndex !== null ? '#52c41a' : '#f04e23',
                          color: 'white',
                          borderRadius: '6px',
                        }}
                      >
                        {editIndex !== null ? 'Update' : 'Add'}
                      </Button>
                    </Col>
                  </Row>

                  {familyList.length > 0 && (
                    <div className="mt-3">
                      <Table
                        bordered
                        dataSource={familyList.map((item, index) => ({
                          key: index,
                          ...item,
                        }))}
                        columns={columns}
                        pagination={{
                          current: currentPage,
                          pageSize: pageSize,
                          onChange: (page, size) => {
                            setCurrentPage(page)
                            setPageSize(size)
                          },
                        }}
                        className="shadow rounded custom-table p-0"
                        style={{
                          overflowX: 'auto',
                          border: '1px solid #dfdfdf',
                        }}
                      />
                    </div>
                  )}

                  <Divider />

                  <h5 className="mt-3">Child Welfare Committee Details -</h5>
                  <Row gutter={16} className="p-2 border rounded">
                    <Col xs={24} md={6} className="">
                      <Form.Item
                        label="First Filed Order Date"
                        name="firstFiledOrderDate"
                        rules={[
                          {
                            required: true,
                            message: 'Please select order date',
                          },
                        ]}
                      >
                        <DatePicker
                          style={{ width: '100%' }}
                          format="DD-MM-YYYY"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={6} className="">
                      <Form.Item
                        label="Form of Order"
                        name="formOfOrder"
                        rules={[
                          {
                            required: true,
                            message: 'Please select form of order',
                          },
                        ]}
                      >
                        <Radio.Group
                          className="border p-1 rounded"
                          style={{ backgroundColor: '#d4d4d4' }}
                        >
                          <Radio value="1">In Writing</Radio>
                          <Radio value="2">What's App</Radio>
                        </Radio.Group>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={12}>
                      <Form.Item
                        label="Act and Section"
                        name="actAndSection"
                        rules={[
                          {
                            required: true,
                            message: 'Please select act and section',
                          },
                        ]}
                      >
                        <Select
                          mode="multiple"
                          placeholder="Select Act and Section"
                          loading={loading}
                          optionFilterProp="children"
                          allowClear
                          showSearch
                        >
                          {actSections.map((item) => (
                            <Option key={item.id} value={item.id}>
                              {item.act_and_sec || item.act_and_sec}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={18}>
                      <Form.Item
                        label="Child Details"
                        name="childDetails"
                        rules={[
                          {
                            required: true,
                            message: 'Please enter child details',
                          },
                        ]}
                      >
                        <Input.TextArea
                          rows={3}
                          placeholder="Enter child details"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={6}></Col>
                  </Row>

                  <Divider />

                  <h5 className="mt-3">Medical Information -</h5>
                  <Row gutter={16} className="p-2 border rounded">
                    <Col xs={24} md={6}>
                      <Form.Item
                        label="Height (cm)"
                        name="height"
                        rules={[
                          { required: true, message: 'Please select height' },
                        ]}
                      >
                        <Select placeholder="Select height">
                          {Array.from({ length: 161 }, (_, i) => {
                            const height = 50 + i // from 120cm to 200cm
                            return (
                              <Option key={height} value={height}>
                                {height} cm
                              </Option>
                            )
                          })}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={6}>
                      <Form.Item
                        label="Weight (kg)"
                        name="weight"
                        rules={[
                          { required: true, message: 'Please select weight' },
                        ]}
                      >
                        <Select placeholder="Select weight">
                          {Array.from({ length: 151 }, (_, i) => {
                            const weight = 1 + i // from 30kg to 150kg
                            return (
                              <Option key={weight} value={weight}>
                                {weight} kg
                              </Option>
                            )
                          })}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={6}>
                      <Form.Item
                        label="Blood Group"
                        name="bloodGroup"
                        rules={[
                          {
                            required: true,
                            message: 'Please select blood group',
                          },
                        ]}
                      >
                        <Select placeholder="Select blood group">
                          {[
                            'A+',
                            'A-',
                            'B+',
                            'B-',
                            'AB+',
                            'AB-',
                            'O+',
                            'O-',
                          ].map((group) => (
                            <Option key={group} value={group}>
                              {group}
                            </Option>
                          ))}
                        </Select>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={6}>
                      <Form.Item label="Menstrual Cycle Date" name="periodDate">
                        <DatePicker
                          style={{ width: '100%' }}
                          format="DD-MM-YYYY"
                        />
                      </Form.Item>
                    </Col>

                    <Col xs={24} lg={14}>
                      <Form.Item label="Health History" name="healthHistory">
                        <Input.TextArea
                          rows={5}
                          placeholder="Enter health history"
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={24} lg={10}>
                      <Form.Item label="Birth Mark on Body" name="birthMark">
                        <Input.TextArea
                          rows={2}
                          placeholder="Describe birth mark"
                        />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Divider />

                  <h5 className="mt-3">Education Information -</h5>
                  <Row gutter={16} className="p-2 border rounded">
                    <Col xs={24} md={6} lg={4}>
                      <Form.Item label="Standard" name="standard">
                        <Input placeholder="Enter standard" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={10} lg={9}>
                      <Form.Item label="School Name" name="schoolName">
                        <Input placeholder="Enter school name" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={8} lg={5}>
                      <Form.Item label="Medium" name="medium">
                        <Input placeholder="Enter medium (e.g., English)" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={6} lg={6}>
                      <Form.Item
                        label="School Leaving Certificate"
                        name="schoolLeavingCertificate"
                        valuePropName="fileList"
                        getValueFromEvent={(e) => {
                          return Array.isArray(e?.fileList) ? e.fileList : []
                        }}
                      >
                        <Upload
                          accept=".jpg,.jpeg,.png,.pdf"
                          beforeUpload={(file) => {
                            const allowedTypes = [
                              'image/jpeg',
                              'image/jpg',
                              'image/png',
                              'application/pdf',
                            ]

                            const isAllowedType = allowedTypes.includes(
                              file.type,
                            )

                            if (!isAllowedType) {
                              toast.error(
                                'Only JPG, PNG, and PDF files are allowed!',
                              )
                              return Upload.LIST_IGNORE
                            }

                            const isLt3M = file.size / 1024 / 1024 < 3

                            if (!isLt3M) {
                              toast.warn('File must be smaller than 3MB!')
                              return Upload.LIST_IGNORE
                            }

                            return false // prevent automatic upload
                          }}
                          maxCount={1}
                          listType="picture"
                        >
                          <Button icon={<UploadOutlined />}>
                            Click to Upload (Max 3MB)
                          </Button>
                        </Upload>
                      </Form.Item>
                    </Col>
                  </Row>

                  <Divider />

                  <h5 className="mt-3">
                    Family background and current situation -
                  </h5>
                  <Row gutter={16} className="p-2 border rounded">
                    <Col xs={24} md={16}>
                      <Form.Item
                        label={
                          <span style={{ color: 'gray' }}>
                            • Visitor Details -
                          </span>
                        }
                      >
                        <Input.Group>
                          <Row gutter={16}>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="visitorName"
                                label="Visitor Name"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{ marginBottom: 0 }}
                              >
                                <Input placeholder="Enter name" />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="visitorRelation"
                                label="Relation"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{ marginBottom: 0 }}
                              >
                                <Input placeholder="Enter relation" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Input.Group>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={8} className=""></Col>

                    <Col xs={24} md={16}>
                      <Form.Item
                        label={
                          <span style={{ color: 'gray' }}>
                            • The person taking responsibility after the death
                            of the parents -
                          </span>
                        }
                      >
                        <Input.Group>
                          <Row gutter={16}>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="personName"
                                label="Person Name"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{ marginBottom: 0 }}
                              >
                                <Input placeholder="Enter name" />
                              </Form.Item>
                            </Col>
                            <Col xs={24} md={12}>
                              <Form.Item
                                name="personRelation"
                                label="Relation"
                                labelCol={{ span: 24 }}
                                wrapperCol={{ span: 24 }}
                                style={{ marginBottom: 0 }}
                              >
                                <Input placeholder="Enter relation" />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Input.Group>
                      </Form.Item>
                    </Col>

                    <Col xs={24} md={8} className=""></Col>

                    <Col xs={24} md={24}>
                      <Form.Item
                        label="History of the children's case"
                        name="childrenCaseHistory"
                      >
                        <Input.TextArea rows={5} placeholder="Enter history" />
                      </Form.Item>
                    </Col>
                  </Row>

                  {/*  Buttons */}
                  <Row justify="end" className="pb-5 pt-3">
                    <Space>
                      <Button
                        htmlType="reset"
                        onClick={() => {
                          form.resetFields()
                          setShowForm(false)
                          setEditId(null)
                          setPhotoPreview(null)
                        }}
                      >
                        Cancel
                      </Button>
                      <Button
                        type="primary"
                        htmlType="submit"
                        loading={loading}
                      >
                        {editId ? 'Update' : 'Submit'}
                      </Button>
                    </Space>
                  </Row>
                </Form>
              </div>
            </Spin>
          )}

          {/* ===== DELETE MODAL ===== */}
          <Modal
            title="Confirm Delete"
            open={deleteModal}
            onOk={handleDeleteStudent}
            onCancel={() => setDeleteModal(false)}
          >
            Are you sure you want to delete this record?
          </Modal>

          {/* ===== VIEW MODAL ===== */}

          <Modal
            title="👁 Student Full Details"
            open={viewModalVisible}
            onCancel={() => setViewModalVisible(false)}
            footer={[
              <Button type="primary" onClick={() => setViewModalVisible(false)}>
                Close
              </Button>,
            ]}
            width={900}
            style={{
              top: 20, // space from top
              paddingBottom: 50, // space from bottom
            }}
            centered
            bodyStyle={{
              maxHeight: '75vh', // control height
              overflowY: 'auto',
              overflowX: 'hidden',
              paddingBottom: 10,
            }}
          >
            {viewData && (
              <div className="view-container py-md-5 px-md-2">
                {/* ================= HEADER WITH IMAGE ================= */}
                <Row
                  gutter={[16, 12]}
                  className="py-2"
                  align="middle"
                  style={{ marginBottom: 20 }}
                >
                  <Col xs={24} md={6} lg={6}>
                    <div className="file-card text-center">
                      {viewData.pic ? (
                        <img
                          src={
                            viewData.pic ? `${IMG_URL}${viewData.pic}` : null
                          }
                          alt="Student"
                          className="student-photo"
                        />
                      ) : (
                        <div className="student-photo view-box">No Image</div>
                      )}
                    </div>
                  </Col>

                  <Col xs={24} md={11} lg={11}>
                    <h3 style={{ marginBottom: 5 }}>
                      {viewData.fname} {viewData.mname} {viewData.lname}
                    </h3>
                    <h6 className="pt-2 text-black" style={{ margin: 0 }}>
                      <b>Registration No:</b> {viewData.reg_no}
                    </h6>
                    <h6 className="pt-2 text-black" style={{ margin: 0 }}>
                      <b>Admission Type:</b>{' '}
                      {admissionTypeMap[viewData.admission_type]}
                    </h6>
                  </Col>
                </Row>

                <Divider />

                <Row gutter={[16, 12]}>
                  <Col xs={24} md={17} lg={17} >
                    {/* ================= PERSONAL INFO ================= */}
                    <div className="section-title">
                      <h5>Personal Information</h5>
                    </div>
                    <Divider />

                    <Row gutter={[16, 12]}>
                      <Col span={6}>
                        <b>Gender:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">
                          {genderMap[viewData.gender] || '-'}
                        </div>
                      </Col>

                      <Col span={6}>
                        <b>Admission Date:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">
                          {viewData.admission_date
                            ? dayjs(viewData.admission_date).format(
                                'DD-MM-YYYY',
                              )
                            : '-'}
                        </div>
                      </Col>

                      <Col span={6}>
                        <b>Birth Date:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">
                          {viewData.birth_date
                            ? dayjs(viewData.birth_date).format('DD-MM-YYYY')
                            : '-'}
                        </div>
                      </Col>

                      <Col span={6}>
                        <b>Birth Place:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">
                          {viewData.birth_place || '-'}
                        </div>
                      </Col>

                      <Col span={6}>
                        <b>Aadhar No:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">
                          {viewData.aadhar_no || '-'}
                        </div>
                      </Col>

                      <Col span={6}>
                        <b>Parent Mobile:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">
                          {viewData.parent_mobile || '-'}
                        </div>
                      </Col>

                      <Col span={6}>
                        <b>Current Address:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">
                          {viewData.current_address || '-'}
                        </div>
                      </Col>

                      <Col span={6}>
                        <b>Permanent Address:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">
                          {viewData.permanent_address || '-'}
                        </div>
                      </Col>

                      <Col span={6}>
                        <b>Police Station:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">
                          {viewData.police_station_name || '-'}
                        </div>
                      </Col>

                      <Col span={6}>
                        <b>Police Contact:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">
                          {viewData.police_contact || '-'}
                        </div>
                      </Col>
                    </Row>
                  </Col>

                  <Col xs={24} md={7} lg={7}>
                    {/* ================= FORM STATUS ================= */}
                    <Card title="Form Status" className='shadow border'  style={{backgroundColor:"#e6f4ff"}}>
                      {Object.entries(statusData).map(([key, value]) => (
                        <div
                          key={key}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: 10,
                            fontSize: 15,
                          }}
                        >
                          {value === 1 ? (
                            <CheckSquareOutlined
                              style={{ color: '#52c41a', marginRight: 8 }}
                            />
                          ) : (
                            <BorderOutlined
                              style={{ color: '#aaa', marginRight: 8 }}
                            />
                          )}

                          {formatName(key)}
                        </div>
                      ))}
                    </Card>
                  </Col>
                </Row>

                <Divider />

                {/* ================= FAMILY MEMBERS ================= */}
                <div className="section-title">
                  <h5>Family Members</h5>
                </div>
                <Divider />

                <Table
                  bordered
                  pagination={false}
                  dataSource={viewData.familyMembers || []}
                  rowKey="id"
                  columns={[
                    { title: 'Name', dataIndex: 'name' },
                    { title: 'Relation', dataIndex: 'relation' },
                    { title: 'Age', dataIndex: 'age' },
                    {
                      title: 'Gender',
                      render: (_, rec) => genderMap[rec.gender],
                    },
                    { title: 'Occupation', dataIndex: 'occupation' },
                    { title: 'Contact', dataIndex: 'contact' },
                  ]}
                  className="shadow rounded custom-table p-0"
                  style={{
                    overflowX: 'auto',
                    border: '1px solid #dfdfdf',
                    backgroundColor: 'white',
                  }}
                />

                <Divider />

                {/* ================= MEDICAL INFO ================= */}
                <div className="section-title">
                  <h5>Medical Information</h5>
                </div>
                <Divider />

                <Row gutter={[16, 12]}>
                  <Col span={6}>
                    <b>Height:</b>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {viewData.medicalinfo?.height || '-'} cm
                    </div>
                  </Col>

                  <Col span={6}>
                    <b>Weight:</b>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {viewData.medicalinfo?.weight || '-'} kg
                    </div>
                  </Col>

                  <Col span={6}>
                    <b>Blood Group:</b>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {viewData.medicalinfo?.blood_group || '-'}
                    </div>
                  </Col>

                  <Col span={6}>
                    <b>Menstrual Cycle Date:</b>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {viewData.medicalinfo?.menstrual_cycle_date
                        ? dayjs(
                            viewData.medicalinfo.menstrual_cycle_date,
                          ).format('DD-MM-YYYY')
                        : '-'}
                    </div>
                  </Col>

                  <Col span={6}>
                    <b>Health History:</b>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {viewData.medicalinfo?.health_history || '-'}
                    </div>
                  </Col>

                  <Col span={6}>
                    <b>Birth Mark:</b>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {viewData.medicalinfo?.birth_mark_on_body || '-'}
                    </div>
                  </Col>
                </Row>

                <Divider />

                {/* ================= EDUCATION ================= */}
                <div className="section-title">
                  <h5>Education Information</h5>
                </div>
                <Divider />

                <Row gutter={[16, 12]}>
                  <Col span={6}>
                    <b>Standard:</b>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {viewData.educationinfo?.standard || '-'}
                    </div>
                  </Col>

                  <Col span={6}>
                    <b>School Name:</b>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {viewData.educationinfo?.school_name || '-'}
                    </div>
                  </Col>

                  <Col span={6}>
                    <b>Medium:</b>
                  </Col>
                  <Col span={18}>
                    <div className="view-box">
                      {viewData.educationinfo?.medium || '-'}
                    </div>
                  </Col>

                  <Col span={6}>
                    <b>School Leaving Certificate:</b>
                  </Col>
                  <Col span={18}>
                    <div className="file-card">
                      {viewData.educationinfo?.school_leaving_certificate ? (
                        <a
                          href={
                            IMG_URL +
                            viewData.educationinfo.school_leaving_certificate
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          📄 View School Leaving Certificate
                        </a>
                      ) : (
                        'No File Uploaded'
                      )}
                    </div>
                  </Col>
                </Row>

                <Divider />

                {/* ================= CHILD WELFARE ================= */}
                <div className="section-title">
                  <h5>Child Welfare Committee</h5>
                </div>
                <Divider />

                {viewData.child_welfare_committee_details?.map((item) => (
                  <div key={item.id}>
                    <Row gutter={[16, 12]}>
                      <Col span={6}>
                        <b>Order Date:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">
                          {dayjs(item.first_filed_order_date).format(
                            'DD-MM-YYYY',
                          )}
                        </div>
                      </Col>

                      <Col span={6}>
                        <b>Form Of Order:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">
                          {formOfOrderMap[item.form_of_order]}
                        </div>
                      </Col>

                      <Col span={6}>
                        <b>Act & Section:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">
                          {item.act_and_section_id}
                        </div>
                      </Col>

                      <Col span={6}>
                        <b>Child Details:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">{item.child_details}</div>
                      </Col>
                    </Row>
                    <Divider />
                  </div>
                ))}

                {/* ================= FAMILY BACKGROUND ================= */}
                <div className="section-title">
                  <h5>Family Background</h5>
                </div>
                <Divider />

                {viewData.family_background?.map((item) => (
                  <div key={item.id}>
                    <Row gutter={[16, 12]}>
                      <Col span={6}>
                        <b>Visitor Name:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">{item.visitor_name}</div>
                      </Col>

                      <Col span={6}>
                        <b>Visitor Relation:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">{item.visitor_relation}</div>
                      </Col>

                      <Col span={6}>
                        <b>Responsible Person:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">{item.person_name}</div>
                      </Col>

                      <Col span={6}>
                        <b>Relation:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">{item.person_relation}</div>
                      </Col>

                      <Col span={6}>
                        <b>Case History:</b>
                      </Col>
                      <Col span={18}>
                        <div className="view-box">
                          {item.children_case_history}
                        </div>
                      </Col>
                    </Row>
                    <Divider />
                  </div>
                ))}
              </div>
            )}
          </Modal>
        </div>
      </div>
      <AdminFooter />
    </>
  )
}

export default StudentAdmissionForm
